const Images = {

    logo : require("./Assets/images/logo.png"),
    listing : require("./Assets/images/listingss.png"),
    profile: require("./Assets/images/profile.png"),

    // navicon
    doc : require("./Assets/navicons/doc.png"),
    square : require("./Assets/navicons/square.png"),
   
    // inner page
    smallround: require("./Assets/images/smallround.png"),
    elogo: require("./Assets/images/elogo.png"),
    market: require("./Assets/images/market.png"),
    volume: require("./Assets/images/volume.png"),
    feargreed: require("./Assets/images/feargreed.png"),
    dominance: require("./Assets/images/dominance.png"),
    announcement: require("./Assets/images/announcement.png"),
    bnb: require("./Assets/images/bnb.png"),
    eth: require("./Assets/images/eth.png"),
    menus: require("./Assets/images/menus.png"),
    blockchain: require("./Assets/images/blockchian.png"),

    reddit: require("./Assets/images/reddit.png"),
    github: require("./Assets/images/githubs.png"),

    insta: require("./Assets/images/instagram.png"),
    fb: require("./Assets/images/facebook.png"),
    twitter: require("./Assets/images/twitter.png"),
    youtube: require("./Assets/images/youtube.png"),
    tele: require("./Assets/images/telegram.png"),

    redgraph: require("./Assets/images/redgraph.png"),
    greengraph: require("./Assets/images/greengraph.png"),
    coinbag: require("./Assets/images/coinbag.png"),

    vac1: require("./Assets/images/vac1.png"),
    vac2: require("./Assets/images/vac22.png"),
    vac3: require("./Assets/images/vac3.png"),

    a1logo: require("./Assets/images/a1logo.png"),
    a2logo: require("./Assets/images/a2logo.png"),

    dashgraph: require("./Assets/images/dash_graph.png"),
}


export default Images;